import { BasicModal } from "@/ui-components/commonComponents/Modal/BasicModal";
import { Button, ButtonColorType } from "@/ui-components/commonComponents/Button/Button";

import style from "./style.module.css";

interface IConfirmResetModal {
  isOpen: boolean;
  isLoading?: boolean;
  onCancel: () => void;
  onConfirm: () => Promise<void>;
  selectedTestNames: string[];
}

export function ConfirmResetModal({
  isOpen,
  isLoading = false,
  onCancel,
  onConfirm,
  selectedTestNames,
}: IConfirmResetModal) {
  return (
    <BasicModal
      autoHeight={true}
      isModalOpen={isOpen}
      handleCancel={onCancel}
      isClosable={false}
      footer={
        <div className={style.actionButtons}>
          <Button onClick={onCancel} colorType={ButtonColorType.transparentDark}>
            No, Cancel
          </Button>
          <Button isLoading={isLoading} onClick={onConfirm} colorType={ButtonColorType.dark}>
            Yes, Reset
          </Button>
        </div>
      }
    >
      <div className={style.modalContent}>
        <h1 className={style.modalTitle}>Are you sure you want to reset the following tests?</h1>
        <ul className={style.testList}>
          {selectedTestNames.map((testName) => (
            <li key={testName} className={style.testItem}>
              {testName}
            </li>
          ))}
        </ul>
        <p className={style.warningText}>
          By resetting {selectedTestNames.length === 1 ? "this test" : "these tests"}, all answers will be erased and
          timers will be reset.
        </p>
      </div>
    </BasicModal>
  );
}
